import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ReactComponent as IdeaBoxLogo } from '../../static/graphics/logos/ideabox-logo-mid.svg'
import {
    navigateLogin,
    navigateRegister,
    navigateResetPassword,
    resetPasswordRequest,
    resetPasswordSubmit,
    resendCode,
    signIn,
    signUp,
    verifyCode,
} from '../../store/actions/auth'
import SmoAuth from '../../store/api/aws/smo-auth'
import IconButtonLabel from '../common/icon-button-label'
import Loading from '../common/loading'

function isValidEmail(email) {
    var re = /\S+@\S+\.\S+/
    return re.test(email)
}

function isValidPassword(password) {
    return (
        password.length >= 8 && password.match(/\d/) && password.match(/[a-z]/)
    )
}

function isNumeric(value) {
    return /^-?\d+$/.test(value)
}

function setAuthUserProperty(context, propertyName, value) {
    context.setState((prevState) => {
        var prevObj = prevState.authUser
        prevObj[propertyName] = value
        return prevObj
    })
}

export class LoginView extends React.Component {
    constructor(props) {
        super(props)

        this.smoAuth = new SmoAuth()

        this.state = {
            authUser: {
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                department: '',
            },
            view: this.props.auth.view,
            errorMessage: this.props.auth.errorMessage,
            loading: this.props.auth.loading,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.auth !== this.props.auth) {
            if (this.props.auth.view === 'home') {
                this.props.history.push('/')
            }

            this.setState({
                view: this.props.auth.view, //"login",
                errorMessage: this.props.auth.errorMessage,
                loading: this.props.auth.loading,
            })
        }
    }

    saveDetailsBetweenViews = (authUser) => {
        this.setState({ authUser: authUser })
    }

    render() {
        const renderError = () => {
            if (this.state.errorMessage)
                return (
                    <p className="mt-4 text-center text text-danger">
                        <small>{this.state.errorMessage}</small>
                    </p>
                )
        }

        const renderLoading = () => {
            if (this.state.loading) return <Loading />
        }

        const renderSubView = () => {
            switch (this.state.view) {
                case 'login':
                    return (
                        <LoginSubView
                            onSaveDetailsBetweenViews={
                                this.saveDetailsBetweenViews
                            }
                            signIn={this.props.signIn}
                            navigateRegister={this.props.navigateRegister}
                            navigateResetPassword={
                                this.props.navigateResetPassword
                            }
                            authUser={this.state.authUser}
                        />
                    )
                case 'register':
                    return (
                        <RegisterSubView
                            signUp={this.props.signUp}
                            navigateLogin={this.props.navigateLogin}
                            onSaveDetailsBetweenViews={
                                this.saveDetailsBetweenViews
                            }
                            authUser={this.state.authUser}
                        />
                    )
                case 'verify':
                    return (
                        <ValidateSubView
                            verifyCode={this.props.verifyCode}
                            resendCode={this.props.resendCode}
                            navigateRegister={this.props.navigateRegister}
                            onSaveDetailsBetweenViews={
                                this.saveDetailsBetweenViews
                            }
                            authUser={this.state.authUser}
                        />
                    )
                case 'reset':
                    return (
                        <ResetPasswordSubView
                            resetRequested={this.props.auth.resetRequested}
                            resetPasswordSubmit={this.props.resetPasswordSubmit}
                            resetPasswordRequest={
                                this.props.resetPasswordRequest
                            }
                            navigateResetPassword={
                                this.props.navigateResetPassword
                            }
                            onSaveDetailsBetweenViews={
                                this.saveDetailsBetweenViews
                            }
                            authUser={this.state.authUser}
                        />
                    )
                default:
                    return (
                        <LoginSubView
                            onSaveDetailsBetweenViews={
                                this.saveDetailsBetweenViews
                            }
                            signIn={this.props.signIn}
                            navigateRegister={this.props.navigateRegister}
                            authUser={this.state.authUser}
                        />
                    )
            }
        }

        return (
            <>
                <h1 className="text-primary text-center mb-2">
                    Welcome to the Siemens Mobility Idea Box
                </h1>

                <div className="text-center mb-3">
                    <IdeaBoxLogo
                        className="text-center"
                        style={{
                            width: '150px',
                            view: 'none',
                        }}
                    />

                    {/* <img src={IdeaBoxLogo}></img> */}
                </div>

                {renderLoading()}

                {renderError()}

                <div className="container mb-4 col-lg-4 col-lg-offset-4">
                    {renderSubView()}
                </div>
            </>
        )
    }
}

class LoginSubView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            authUser: this.props.authUser,
        }
    }

    isValid = () => {
        return (
            isValidEmail(this.state.authUser.email) &&
            this.state.authUser.password.length > 0
        )
    }

    onSubmit = () => {
        this.props.onSaveDetailsBetweenViews(this.state.authUser)
        this.props.signIn(this.state.authUser)
    }

    render() {
        return (
            <>
                <h3 className="text-center text-secondary mb-4">Login</h3>
                <input
                    autoFocus
                    type="email"
                    className="form-control mb-2"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={(e) =>
                        setAuthUserProperty(this, 'email', e.target.value)
                    }></input>
                <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="Password"
                    value={this.state.password}
                    onChange={(e) =>
                        setAuthUserProperty(this, 'password', e.target.value)
                    }
                    onKeyDown={(e) => {
                        e.key === 'Enter' && this.isValid() && this.onSubmit()
                    }}></input>

                <div className="mt-4 mb-4 text-center">
                    <IconButtonLabel
                        disabled={!this.isValid()}
                        onClick={this.onSubmit}
                        text="Login"
                        icon="paper-plane"
                    />
                </div>

                <p className="mt-4 text-center text text-secondary">
                    Don't have an account?
                    <button
                        className="icon-btn"
                        onClick={() => {
                            this.props.onSaveDetailsBetweenViews(
                                this.state.authUser
                            )
                            this.props.navigateRegister()
                        }}>
                        {' '}
                        Register.
                    </button>
                </p>

                <p className="mt-2 text-center text text-secondary">
                    Forgot your password?
                    <button
                        className="icon-btn"
                        onClick={() => {
                            this.props.onSaveDetailsBetweenViews(
                                this.state.authUser
                            )
                            this.props.navigateResetPassword()
                        }}>
                        {' '}
                        Reset Password.
                    </button>
                </p>
            </>
        )
    }
}

class RegisterSubView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            authUser: this.props.authUser,
            passwordRetype: '',
            passwordRequirementsVisible: false,
        }
    }

    validation = () => {
        if (
            this.state.authUser.firstName.length === 0 ||
            this.state.authUser.lastName.length === 0 //||
            // this.state.authUser.department.length == 0
        )
            return 'All fields are mandatory.'

        if (!isValidEmail(this.state.authUser.email))
            return 'Invalid email provided.'
        if (!isValidPassword(this.state.authUser.password))
            return 'The password does not meet the minimum requirements.'
        if (this.state.authUser.password !== this.state.passwordRetype)
            return "The passwords don't match!"

        return ''
    }

    onSubmit = () => {
        // Check for problems
        if (this.validation().length > 0) {
            return
        }

        this.props.onSaveDetailsBetweenViews(this.state.authUser)

        this.props.signUp(this.state.authUser)
    }

    render() {
        const validation = this.validation()

        const passwordRequirements = () => {
            const validLength =
                (this.state.authUser.password.length >= 8
                    ? 'text-success'
                    : 'text-danger') + ' text-center mb-0'
            const validNumbers =
                (this.state.authUser.password.match(/\d/)
                    ? 'text-success'
                    : 'text-danger') + ' text-center mb-0'
            const validLetters =
                (this.state.authUser.password.match(/[a-z]/)
                    ? 'text-success'
                    : 'text-danger') + ' text-center mb-0'

            return (
                <div className="mb-2">
                    <p className={validLength}>
                        <small>
                            Password must be atleast 8 characters long.
                        </small>
                    </p>
                    <p className={validNumbers}>
                        <small>Password must contain numbers.</small>
                    </p>
                    <p className={validLetters}>
                        <small>Password must contain lowercase letters.</small>
                    </p>
                </div>
            )
        }

        return (
            <>
                <h3 className="text-center text-secondary mb-4">Register</h3>

                <input
                    autoFocus
                    className="form-control mb-2"
                    placeholder="First Name"
                    onChange={(e) =>
                        setAuthUserProperty(this, 'firstName', e.target.value)
                    }></input>
                <input
                    className="form-control mb-2"
                    placeholder="Last Name"
                    onChange={(e) =>
                        setAuthUserProperty(this, 'lastName', e.target.value)
                    }
                />
                {/* <input
                  className="form-control mb-2"
                  placeholder="Department"
                  onChange={(e) => setAuthUserProperty(this, "department", e.target.value)}
                ></input> */}
                <input
                    className="form-control mb-2"
                    placeholder="Email"
                    value={this.state.authUser.email}
                    onChange={(e) =>
                        setAuthUserProperty(this, 'email', e.target.value)
                    }></input>
                <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="Password"
                    onFocus={(e) =>
                        this.setState({ passwordRequirementsVisible: true })
                    }
                    onBlur={(e) =>
                        this.setState({ passwordRequirementsVisible: false })
                    }
                    onChange={(e) =>
                        setAuthUserProperty(this, 'password', e.target.value)
                    }></input>

                {this.state.passwordRequirementsVisible &&
                    passwordRequirements()}

                <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="Re-type Password"
                    onChange={(e) =>
                        this.setState({ passwordRetype: e.target.value })
                    }></input>

                <p className="text-danger text-center">
                    <small>{validation}</small>
                </p>

                <div className="mt-2 mb-4 text-center">
                    <IconButtonLabel
                        disabled={validation.length > 0}
                        onClick={this.onSubmit}
                        text="Register"
                        icon="paper-plane"
                    />
                </div>

                <p className="mt-4 text-center text-secondary">
                    Already have an account?
                    <button
                        className="icon-btn"
                        onClick={() => {
                            this.props.onSaveDetailsBetweenViews(
                                this.state.authUser
                            )
                            this.props.navigateLogin()
                        }}>
                        {' '}
                        Login
                    </button>
                    .
                </p>
            </>
        )
    }
}

class ValidateSubView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            authUser: this.props.authUser,
            code: '',
        }
    }

    onSubmit = () => {
        this.props.onSaveDetailsBetweenViews(this.state.authUser)
        this.props.verifyCode(this.state.authUser, this.state.code)
    }

    onResendCode = () => {
        this.props.resendCode(this.state.authUser.email)
    }

    isValid = () => {
        return this.state.code.length > 0
    }

    render() {
        return (
            <>
                <h3 className="text-center text-secondary mb-4">
                    Email Verification
                </h3>

                <p className="text-center text-secondary mb-1">
                    <small>
                        A verification code has been sent to your email address.
                        Please wait a few minutes and make sure to check your
                        spam folder.
                    </small>
                </p>

                <p className="mt-1 mb-3 text-center text-secondary">
                    <small>
                        Didn't receive a code?
                        <button
                            className="icon-btn"
                            onClick={this.onResendCode}>
                            Resend Code
                        </button>
                        .
                    </small>
                </p>

                <input
                    autoFocus
                    className="form-control mb-2"
                    placeholder="Verification Code"
                    onChange={(e) => this.setState({ code: e.target.value })}
                    onKeyDown={(e) => {
                        e.key === 'Enter' && this.isValid() && this.onSubmit()
                    }}></input>

                <div className="mt-4 mb-4 text-center">
                    <IconButtonLabel
                        disabled={!this.isValid()}
                        onClick={this.onSubmit}
                        text="Verify"
                        icon="paper-plane"
                    />
                </div>

                <p className="mt-4 text-center text-secondary">
                    Don't have an account?
                    <button
                        className="icon-btn"
                        onClick={() => {
                            this.props.onSaveDetailsBetweenViews(
                                this.state.authUser
                            )
                            this.props.navigateRegister()
                        }}>
                        Register
                    </button>
                    .
                </p>
            </>
        )
    }
}

class ResetPasswordSubView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            authUser: this.props.authUser,
            code: '',
            passwordRetype: '',
            passwordRequirementsVisible: false,
        }
    }

    emailValidation = () => {
        return isValidEmail(this.state.authUser.email)
    }

    submitValidation = () => {
        if (!isNumeric(this.state.code)) return 'Invalid verification code.'
        if (!isValidPassword(this.state.authUser.password))
            return 'The password does not meet the minimum requirements.'
        if (this.state.authUser.password !== this.state.passwordRetype)
            return "The passwords don't match!"
        return ''
    }

    onSubmit = () => {
        this.props.onSaveDetailsBetweenViews(this.state.authUser)
        this.props.resetPasswordSubmit(
            this.state.authUser.email,
            this.state.code,
            this.state.authUser.password
        )
    }

    onRequestReset = () => {
        this.props.resetPasswordRequest(this.state.authUser.email)
    }

    render() {
        const renderRequest = () => {
            const validation = this.emailValidation()
            return (
                <>
                    <input
                        className="form-control mb-2"
                        placeholder="Email"
                        value={this.state.authUser.email}
                        onChange={(e) =>
                            setAuthUserProperty(this, 'email', e.target.value)
                        }></input>

                    <div className="mt-2 mb-4 text-center">
                        <IconButtonLabel
                            disabled={!validation}
                            onClick={this.onRequestReset}
                            text="Request Password Reset"
                            icon="paper-plane"
                        />
                    </div>
                </>
            )
        }

        const renderSubmit = () => {
            const passwordRequirements = () => {
                const validLength =
                    (this.state.authUser.password.length >= 8
                        ? 'text-success'
                        : 'text-danger') + ' text-center mb-0'
                const validNumbers =
                    (this.state.authUser.password.match(/\d/)
                        ? 'text-success'
                        : 'text-danger') + ' text-center mb-0'
                const validLetters =
                    (this.state.authUser.password.match(/[a-z]/)
                        ? 'text-success'
                        : 'text-danger') + ' text-center mb-0'

                return (
                    <div className="mb-2">
                        <p className={validLength}>
                            <small>
                                Password must be atleast 8 characters long.
                            </small>
                        </p>
                        <p className={validNumbers}>
                            <small>Password must contain numbers.</small>
                        </p>
                        <p className={validLetters}>
                            <small>
                                Password must contain lowercase letters.
                            </small>
                        </p>
                    </div>
                )
            }

            const validation = this.submitValidation()

            return (
                <>
                    <p className="text-center text-secondary mb-1">
                        <small>
                            A verification code has been sent to your email
                            address. Please wait a few minutes and make sure to
                            check your spam folder.
                        </small>
                    </p>

                    <p className="text-center text-secondary mb-1">
                        <small>Enter the verification code below.</small>
                    </p>

                    <input
                        autoComplete="off"
                        autoFocus
                        className="form-control mb-2"
                        placeholder="Verification Code"
                        onChange={(e) =>
                            this.setState({ code: e.target.value })
                        }
                        onKeyDown={(e) => {
                            e.key === 'Enter' &&
                                this.isValid() &&
                                this.onSubmit()
                        }}></input>

                    <p className="text-center text-secondary mb-1">
                        <small>Enter your new password.</small>
                    </p>

                    <input
                        type="password"
                        className="form-control mb-2"
                        placeholder="Password"
                        onFocus={(e) =>
                            this.setState({ passwordRequirementsVisible: true })
                        }
                        onBlur={(e) =>
                            this.setState({
                                passwordRequirementsVisible: false,
                            })
                        }
                        onChange={(e) =>
                            setAuthUserProperty(
                                this,
                                'password',
                                e.target.value
                            )
                        }></input>

                    {this.state.passwordRequirementsVisible &&
                        passwordRequirements()}

                    <input
                        type="password"
                        className="form-control mb-2"
                        placeholder="Re-type Password"
                        onChange={(e) =>
                            this.setState({ passwordRetype: e.target.value })
                        }></input>

                    <div className="mt-4 mb-4 text-center">
                        <IconButtonLabel
                            disabled={validation.length > 0}
                            onClick={this.onSubmit}
                            text="Submit"
                            icon="paper-plane"
                        />
                    </div>
                </>
            )
        }

        return (
            <>
                <h3 className="text-center text-secondary mb-4">
                    Reset Password
                </h3>

                {!this.props.resetRequested && renderRequest()}
                {this.props.resetRequested && renderSubmit()}

                <p className="mt-4 text-center text-secondary">
                    Don't have an account?
                    <button
                        className="icon-btn"
                        onClick={() => {
                            this.props.onSaveDetailsBetweenViews(
                                this.state.authUser
                            )
                            this.props.navigateRegister()
                        }}>
                        Register
                    </button>
                    .
                </p>
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
})

const mapDispatchToProps = {
    signUp,
    signIn,
    verifyCode,
    resendCode,
    resetPasswordRequest,
    resetPasswordSubmit,
    navigateRegister,
    navigateLogin,
    navigateResetPassword,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(LoginView)
)
